/* ============================================================
   SOPHIOR — Sticky infokolom PDP (desktop, >= 990px)
   Gebruikt door: sections/sophior-product-info.liquid

   Een infokolom die hoger is dan het viewport plakte met top: 3rem
   direct vast, waardoor de accordeons (Productomschrijving t/m
   Gebruik & Onderhoud) pas bereikbaar waren na het doorscrollen van
   de volledige fotogalerij.

   Dit script stuurt --sophior-info-sticky-top scroll-gedreven aan:
   de top schuift per scrolldelta mee binnen [viewport - kolomhoogte
   - marge, 3rem]. Effect: omlaag scrollen laat de kolom meescrollen
   tot de onderkant in beeld is (dan vastgezet), omhoog scrollen laat
   hem meescrollen tot de titel weer bovenaan pint.

   Bewust NIET het simpele "top = viewport - hoogte"-anker: dat gaf
   (a) een kolomsprong bij laden op een gescrolde positie (scroll
   restoration/reload; eerste paint pint op de 3rem-fallback, waarna
   de negatieve top de kolom honderden px verschoof = CLS) en (b) een
   sprong onder de cursor bij elke hoogtewijziging in vastgezette
   staat (accordeon open/dicht, add-on-bundelregel), omdat de
   onderkant geklemd bleef. Nu blijft de top bij een hoogtewijziging
   gewoon staan en groeit de content naar beneden; alleen de grenzen
   worden herrekend. (Adversariele review 18 aug 2026.)
   ============================================================ */
(function () {
  'use strict';

  var col = document.querySelector('.sophior-product-info__details.product__column-sticky');
  if (!col) return;

  var mq = window.matchMedia('(min-width: 990px)');
  var TOP_MAX = 30;       /* 3rem bij Dawn-root 10px — gelijk aan de CSS-fallback */
  var BOTTOM_MARGIN = 24; /* ademruimte onder de kolom in vastgezette staat */

  var top = TOP_MAX;
  var min = TOP_MAX;
  var lastY = window.scrollY;
  var applied = null;

  /* Redesign golf 1 · F0-d schil (s08-schil, fragment s08-schil/assets-sophior-info-sticky-js.md):
     met sophior_uitrol_schil_fix aan plakt de header (72 px) en zet
     sophior-header.css --sophior-info-sticky-offset op deze kolom; de CSS telt
     die offset bij de top op. De ondergrens trekt hem hier weer af, zodat de
     onderkant van een hoge kolom in beeld blijft. Uit: geen waarde, offset 0,
     gedrag ongewijzigd. */
  function chromeOffset() {
    var v = parseFloat(window.getComputedStyle(col).getPropertyValue('--sophior-info-sticky-offset'));
    return isNaN(v) ? 0 : v;
  }

  function clampTop() {
    if (top < min) top = min;
    if (top > TOP_MAX) top = TOP_MAX;
  }

  function apply() {
    if (top === applied) return;
    applied = top;
    col.style.setProperty('--sophior-info-sticky-top', top + 'px');
  }

  /* Grenzen herrekenen zonder de kolom te verplaatsen: top blijft waar hij
     staat (geen sprong bij accordeon open/dicht of add-on-regel), alleen
     buiten de nieuwe grenzen wordt hij bijgeklemd */
  function refreshBounds() {
    if (!mq.matches) {
      top = TOP_MAX;
      applied = null;
      col.style.removeProperty('--sophior-info-sticky-top');
      return;
    }
    min = Math.min(TOP_MAX, window.innerHeight - col.offsetHeight - BOTTOM_MARGIN - chromeOffset());
    clampTop();
    apply();
  }

  function onScroll() {
    var y = window.scrollY;
    var delta = y - lastY;
    lastY = y;
    if (!mq.matches || delta === 0) return;
    top -= delta;
    clampTop();
    apply();
  }

  refreshBounds();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', refreshBounds);
  /* Kolomhoogte verandert bij accordeon open/dicht, add-on bundeltotaal,
     variantwissel en late webfont-/widget-loads — ResizeObserver vangt alles */
  if ('ResizeObserver' in window) {
    new ResizeObserver(refreshBounds).observe(col);
  }
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', refreshBounds);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(refreshBounds);
  }
})();
